import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'helpers/utils';
import { baseUrl } from 'authConfig';
import { customFetchBaseQuery } from './customFetch';

export const countryApi = createApi({
  reducerPath: 'countryApi',
  tagTypes: ['Country'],
  baseQuery: customFetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getcountries: builder.mutation({
      query: ({ token }) => ({
        url: 'commondata/getcountries',
        headers: getHeaders(token),
        method: 'GET',
      }),
      invalidatesTags: () => [{ type: 'Country', id: 'LIST' }],
    }),
  }),
});

export const { useGetcountriesMutation } = countryApi;
